import angular from 'angular';

(function() {
    'use strict';

    // Component DEF
    var kissOrderSection = {
        controller: 'OrderSectionCtrl as vm',
        templateUrl: require('./order-section.html'),
        bindings: {
            addFn: '&',
            removeItemFn: '&',
            editable: '<', // Binding dans un sens parent controller => controller du composant
            fullAttributes: '<',
            orderAttributes: '<',
            initClosed: '<',
            sectionAttributes: '<',
            typeSection: '@',
            sections:'<'
        }
    };

    // Add to the App
    angular.module('app.principal').component('kissOrderSection', kissOrderSection);
})();
